"use strict";
// "core" plugin definition that includes a few "baked in"
// extension points
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    pluginId: "cisco.dna.core",
    extensionPoints: {
        boot: {
            properties: {
                module: { $ref: "dna/ui/plugin#/module" }
            },
            required: ["module"]
        },
        // The "cisco.dna.core/startup" extension is now being handled by the "cisco.dna.core.startup" plugin
        // but for compatibility we need to keep it defined here until we can get plugins to update their contrib endpoints
        startup: {
            properties: {
                module: { $ref: "dna/ui/plugin#/module" }
            },
            required: ["module"]
        },
        service: {
            properties: {
                name: { type: "string" },
                requiresContext: { type: "boolean" },
                module: { $ref: "dna/ui/plugin#/module" }
            },
            required: ["name", "module"]
        },
        view: {
            properties: {
                name: { type: "string" },
                module: { $ref: "dna/ui/plugin#/module" },
                viewRef: { $ref: "dna/ui/plugin#/viewRef" }
            },
            oneOf: [{ required: ["name", "module"] }, { required: ["name", "viewRef"] }]
        },
        featureFlag: {
            properties: {
                id: { type: "string" },
                category: { type: "string" },
                label: { type: "string" }
            },
            required: ["id", "label"]
        },
        filter: {
            properties: {
                name: { type: "string" },
                module: { $ref: "dna/ui/plugin#/module" }
            },
            required: ["name", "module"]
        }
    }
};
